import { observable, action, runInAction, computed } from 'mobx';
import BasePaginationStore from '@store/Common/BasePaginationStore';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import { server_address} from "@src/env-config";
import {message} from 'antd';
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import MyAgentStore from '@store/LoginUser/MyAgentStore';

class Item {
    constructor(data) {
        this.init(data);
    }
    @action
    init(data){
        if (data===undefined) {
            return
        }
        for (let attr in data){
            this[attr] = data[attr];
        }
    }
    // 交易号
    @observable
    id = "";

    // 手机号
    @observable
    nick_name = "";

    // 昵称
    @observable
    pet_name = "";

    // 代理
    @observable
    payment_id = "";

    //代充时间
    @observable
    time = '';

    //代充金额
    @observable
    in_money ='';

    //赠送金额
    @observable
    donation_amount ='';

    //充值说明
    @observable
    description = '';

}
class PaginationStore extends BasePaginationStore{

}

/**
 * 页面头部筛选过滤器字段值
 */

class FilterStore {
    //是否初始化过
    is_init;

    search;
    type;
    proxy_type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
    //代理昵称
    agent;
    nick_name;
    pet_name;
    id;
    type_time

    @action
    setAttr({agent,search,nick_name,type,pet_name,id,type_time}){
        this.resetAttr();
        this.search = search;
        this.type = type;
        this.id = id;
        if (pet_name !='' || pet_name != undefined)
        {
            this.nick_name = nick_name;
            this.pet_name = pet_name;
        }
        if (agent != undefined || agent != '')
        {
            this.agent = agent;
            this.id = MyAgentStore.findMyAgentId(agent);
        }

        this.type_time = type_time;
        this.is_init = true;
    }
    getAttr(){
        return {
            search:this.search,
            nick_name:this.nick_name,
            pet_name:this.pet_name,
            type:this.type,
            id:this.id,
            proxy_type:this.proxy_type,
            type_time:this.type_time,
        }
    }
    setDefault(type){
        this.resetAttr();
        this.type = type;
        this.proxy_type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
        this.is_init = true;
    }

    @action
    resetAttr(){
        this.search = undefined;
        this.id = undefined;
        this.type = undefined;
        this.proxy_type = undefined;
        this.nick_name = undefined;
        this.pet_name = undefined;
        this.type_time = 6;
        this.is_init= undefined;
    }
}
let filter_store = new FilterStore();

class ItemStore {
    constructor(pagination){
        this.init(pagination);
    }

    @action
    init(pagination){
        this.pagination_store = pagination;
    }

    @observable
    item_map = new Map();

    @observable
    pagination_store;

    @observable
    sumInMoney = 0;

    /**
     * item 数组列表
     */

    @computed
    get item_array(){
        let res = [];
        this.item_map.forEach((values, key) => {
            res.push(values);
        });
        return res;
    }

    @action
    reloadDatas(filter) {
        this.new_num = 0;
        this.new_total = 0;
        this.pagination_store.clear();

        if (filter == undefined)
        {
            if (filter_store.is_init == undefined) {
                filter_store.setDefault()
            }
        } else {
            filter_store.setAttr(filter);
        }

        this.searchByFilter(
            {
                desc:1,
                order:'time'
            }
        );
    }

    /**
     * 根据条件搜索item
     */
    async searchByFilter(page_opts){

        let page_option = {
            page: this.pagination_store.page_cur,
            page_size: this.pagination_store.page_size,
            ...filter_store.getAttr(),
            ...page_opts
        }

        let res = await this._getItemArray(page_option);
        return res;
    }
    /**
     * 获取item 列表
     */
    async _getItemArray(page_option = {}) {
        let url = fetchUrl.admin.agentTopUpList;
        let res = await service.fetchData({
            path: url,
            params: {
                ...page_option
            }
        });
        service.responseHandle({
            res: res,
            success_handle: (res) => {
                runInAction(() => {
                    this.item_map.clear();
                    res.data.data.forEach((item, index) => {
                        this.item_map.set(item.id, new Item(item));
                    });
                    this.pagination_store.setAttr(res.data.page);
                    this.sumInMoney = res.data.sumInMoney;
                })
            },
            fail_handle: (res) => {
                message.error(res.error.error_data,3);
                this.pagination_store.clear();
                filter_store.resetAttr();
                this.item_map.clear();
            }
        })
        return res;
    }
}

let pagination_store = new PaginationStore();
let item_store = new ItemStore(pagination_store)
export {
    pagination_store,
    filter_store,
}
export default item_store


// WEBPACK FOOTER //
// ./src/Store/Statistic/GeneraCharge/GeneraChargeStore.js